import { FC, memo } from 'react'
import { Flex, Text } from '@chakra-ui/react'

import { Citizen } from 'CitizenProfile/types'
import { getFormattedAddress } from 'utils/transforms/string'

type Props = {
  citizen: Citizen
}

const CitizenCardAddress: FC<Props> = ({ citizen }) => {
  return (
    <Flex width="100%" direction="column" gap={1}>
      <Text variant="secondary" mb={2}>
        Endereço
      </Text>

      <Text>{getFormattedAddress(citizen, 'main_address')}</Text>
    </Flex>
  )
}

export default memo(CitizenCardAddress)
